<template>
  <base-table-component
    :title="title"
    :description="description"
    :rows="effectiveRows"
    :columns="columns"
    :summary-row="summaryRow"
  />
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { ITableColumn, TableUtils } from '@/utils/table'
import TableMixin, { ColumnName } from './mixins/TableMixin.vue'
import BaseTableComponent from './components/BaseTableComponent.vue'
import { MESSAGE_TYPE } from '@/utils/constants'

@Options({
  name: 'StoryTable',
  components: {
    BaseTableComponent,
  },
})
export default class StoryTable extends mixins(TableMixin) {
  protected getDefaultMessageType(): string {
    return MESSAGE_TYPE.STORY
  }

  get columns(): ITableColumn[] {
    return [
      ...this.baseColumns,
      {
        name: 'start_story_count',
        label: this.$t('label.start_count'),
        field: 'start_story_count',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      ...this.getCommonColumns([ColumnName.CLICKS]),
      {
        name: ColumnName.GTR,
        label: 'GTR',
        field: (row: any) => TableUtils.calculatePercent(row.total_user_of_goal, row.total_click),
        align: 'right',
        format: TableUtils.formatPercent,
      },
      ...this.getCommonColumns([ColumnName.GOAL, ColumnName.CVR, ColumnName.TARGET]),
    ]
  }

  protected calculateSummary(): Record<string, number> {
    const summary = (TableMixin.prototype as any).calculateSummary.call(this)

    summary.gtr = TableUtils.calculatePercent(summary.total_user_of_goal, summary.total_click)

    return summary
  }
}
</script>
